<template>
    <div v-if="!this.loading && this.job && this.authenticated && !this.isClosed">
        <v-container class="my-2">
            <v-row justify="center">
                <v-img
                    src="../assets/images/perfecta_full_logo.png"
                    max-width="200px"
                ></v-img>
            </v-row>
        </v-container>
        <v-container class="px-1 mt-2" v-if="!finished && !declined">
            <v-row class="px-1 mx-1">
                <v-col cols="8">
                    <v-row>
                        <v-col cols="12" class="px-1 py-1 text"><p class="label bold">Uppdragstitel: </p> {{ job.title }}</v-col><br>
                        <v-col cols="12" class="px-1 py-1 text"><p class="label bold">Uppdragsnr: </p> #{{ job.jobNo }}</v-col><br>
                        <v-col cols="12" class="px-1 py-1 text" style="float: left;font-weight:bold;">{{ job.activityName }}</v-col>
                        <v-col cols="12" class="px-1 py-1 text"><p class="label bold">Kund: </p>{{ job.customerName }}</v-col>
                        <v-col cols="12" class="px-1 py-1 text" v-if="job.customerProjectName"><p class="label bold">Kundprojekt: </p>{{ job.customerProjectName }}</v-col>
                        <v-col cols="12" class="px-1 py-1 text" v-if="projectNo"><p class="label bold">Kundprojektnr.: </p>{{ projectNo }}</v-col>
                        <v-col cols="12" class="px-1 py-1 text" v-if="job.assetName"><p class="label bold">Objekt: </p>{{ job.assetName }}</v-col>
                    </v-row>
                </v-col>
                <v-col cols="4">
                    <div v-if="objectImageUrl">
                        <v-img :src="objectImageUrl" style="max-width:100px" justify="end"></v-img>
                        <div v-if="showDocuments" style="text-align:right;font-weight:bold;"><router-link :to="{ name: 'Documents', params: { documents: job.documents, jobId: this.$jobId, accessToken: this.$accessToken }}">Visa mera</router-link></div>
                    </div>
                </v-col>
            </v-row>
            <br>
            <v-row class="px-1 mx-1">
                <v-col cols="12" class="px-1 py-1 text" v-if="address"><p class="label bold">Adress: </p><a :href="addresHref" target="_blank">{{ address }}</a></v-col>
                <v-col cols="12" class="px-1 py-1 text"><p class="label bold">Kontaktperson: </p>{{ contactName }}</v-col><br>
                <v-col cols="12" class="px-1 py-1 text" v-if="contactPhone"><p class="label bold">Telefon: </p><a :href='"tel:{{contactPhone}}"'>{{ contactPhone }}</a></v-col>
                <v-col cols="12" class="px-1 pt-1 pb-4 text" v-if="contactEmailAddress"><p class="label bold">Epost: </p><a :href='"mailto:{{contactEmailAddress}}"'>{{ contactEmailAddress }}</a></v-col>
                <v-col cols="12" class="px-1 py-1 text label bold">ARBETSBESKRIVNING</v-col>
                <v-col cols="12" class="px-1 py-1 text" :class="{ 'border': job.description }">{{ job.description }}</v-col>
                <v-col cols="12" style="padding:0px;">
                    <template v-if="inventoryOrInspectionJob">
                        <div class="my-2">
                            <v-col class="px-1 py-1 text label bold">Anläggningstillgångar/Maskinpark</v-col>
                                <template v-if="customerProjectAssets.length > 0">
                                    <v-row v-for="asset in customerProjectAssets" :key="asset.id" class="job-asset">
                                        <v-col cols="7" class="asset px-0 py-0 my-2" :class="[ !accepted ? 'disabled' : '',  inspected(asset) ? 'inspected' : 'not-inspected']" @click="clickAsset(asset)">
                                            <router-link :to="{ name: 'Asset', params:{ id: asset.id, type: asset.assetTypeName , from: 'job', yearlyInspection: yearlyInspection, resourceName: resourceName }}" class="px-1 py-1">{{ asset.name }} {{ asset.assetNo }}</router-link>
                                        </v-col>
                                        <v-col cols="5" v-if="!inspected(asset)" class="inspection-needed mx-0">Inspektion saknas</v-col>
                                    </v-row>
                                </template>
                                <template v-else>
                                    <v-col class="px-1 py-1 text border">Inga anläggningtillgångar funna på anläggningen</v-col>
                                </template>
                        </div>
                    </template>
                </v-col>
            </v-row>
            <v-row class="px-1 mx-1" v-if="!inventoryOrInspectionJob">
                <v-col class="text bold">Arbetet behöver påbörjas inom 2 arbetsdagar....</v-col>
            </v-row>
            <template v-if="accepted">
                <v-row class="px-1 mx-1 pb-2">
                    <v-col class="px-1 py-1 text accepted-by">
                        {{ acceptedBy }}
                    </v-col>
                </v-row>
                <v-row class="px-1 mx-1" v-if="!inventoryOrInspectionJob">
                    <v-col class="px-1 py-1 text latest-date" v-if="extendedTime">
                        {{ extendedTime }}
                    </v-col>
                    <v-col class="px-1 py-1 text latest-date" v-else>
                        {{ latestFinished }}
                    </v-col>
                </v-row>
                <v-row class="px-1 mx-1" v-if="inventoryOrInspectionJob">
                    <v-col>
                        <v-btn
                            style="white-space: pre-line"
                            color="addStuff"
                            ref="addAsset"
                            @click="$router.push({  name: 'Protocol', params: { basicFormComplete: isBasicFormComplete, yearlyInspection: yearlyInspection, resourceName: resourceName }})"
                            tile
                            block>{{ addObjectText }}</v-btn>
                    </v-col>
                </v-row>
                <v-row class="px-1 mx-1">
                    <v-col class="px-1 py-1 text" :class="inventoryOrInspectionJob ? 'mt-2' : 'mt-6'">Kommenterar angående ärendet:</v-col>
                </v-row>
                <v-row class="px-1 mx-1" :class="{ missing: errorMessage }">
                <v-col class="px-1 py-1 text"><p class="label bold">Ditt namn: </p>
                    <input
                        v-model="name"
                        class="border"
                        style="width:175px;"
                        ref="name">
                </v-col>
                </v-row>
                <v-row class="px-1">
                    <v-col class="py-1"><textarea v-model="comment" class="border" style="width: 100%"></textarea></v-col>
                </v-row>
                <v-row class="px-1 mx-1">
                    <v-col class="px-1 pt-1 pb-2">
                        <v-btn
                            ref="comment"
                            @click="clickAddNote()"
                            tile
                            block
                            >Lägg till kommentarer</v-btn>
                    </v-col>
                </v-row>
                <v-row class="px-1 mx-1">
                    <v-col cols="8">
                        <v-file-input
                            label="Välj dokument"
                            outlined
                            dense
                            v-model="file"
                            @change="fileSelected"
                        ></v-file-input>
                    </v-col>
                    <v-col class="text-right" cols="4">
                        <v-btn
                            @click="clickUploadDocument()"
                            tile
                            width="100"
                            :color="this.file ? 'accept' : ''"
                            :disabled="!this.file"
                            >Ladda upp</v-btn>
                    </v-col>
                </v-row>
                <template v-if="notes && notes.length > 0">
                    <template v-for="note in notes">
                        <note :note="note" :key="note.id" v-if="!note.internal">
                        </note>
                    </template>
                </template>
                <v-row class="px-1 mx-1">
                    <v-col>
                        <v-btn
                            color="finishJob"
                            ref="finishJob"
                            @click="finishJob()"
                            tile
                            block>Uppdrag slutfört</v-btn>
                    </v-col>
                </v-row>
            </template>
            <v-row class="px-1 mx-1" :class="{ missing: errorMessage }" v-else>
                <v-col class="px-1 py-1 text"><p class="label bold">Uppdrag accepterad av: </p>
                    <input
                        v-model="name"
                        class="border"
                        style="width:160px;"
                        ref="name">
                </v-col>
            </v-row>
            <v-row class="px-1 mx-1" v-if="!accepted">
                <v-col>
                    <v-btn
                        color="accept"
                        ref="accept"
                        @click="accept()"
                        tile
                        block
                        :disabled="loading || accepted || declined">Acceptera</v-btn>
                </v-col>
                <v-col>
                    <v-btn
                    color="decline"
                    ref="decline"
                    @click="decline()"
                    tile
                    block
                    :disabled="loading || accepted || declined">Avböj</v-btn>
                </v-col>
            </v-row>
        </v-container>
        <v-container class="px-1" v-else-if="declined">
            <v-row class="px-1 mx-1">
                <v-col class="px-1 py-1 text">
                    {{ infoText }} avböjt
                </v-col>
            </v-row>
            <template v-if="finished">
                <v-row class="px-1 mx-1">
                    <v-col class="px-1 py-1 text">
                        <p class="label bold">Datum: </p>{{ finishedDate }}
                    </v-col>
                </v-row>
                <v-row class="px-1 mx-1">
                    <v-col class="px-1 py-1 text">
                        <p class="label bold">Kl: </p>{{ finishedTime }}
                    </v-col>
                </v-row>
            </template>
            <v-row class="px-1 mx-1">
                <v-col class="px-1 py-1 text">
                    Vid eventuella frågor ring {{ perfectaPhone }}
                </v-col>
            </v-row>
        </v-container>
        <v-container class="px-1" v-else-if="finished">
            <v-row class="px-1 mx-1">
                <v-col class="px-1 py-1 text">
                    {{ infoText }} slutfört
                </v-col>
            </v-row>
            <v-row class="px-1 mx-1">
                <v-col class="px-1 py-1 text">
                    <p class="label bold">Datum: </p>{{ finishedDate }}
                </v-col>
            </v-row>
            <v-row class="px-1 mx-1">
                <v-col class="px-1 py-1 text">
                    <p class="label bold">Kl: </p>{{ finishedTime }}
                </v-col>
            </v-row>
            <v-row class="px-1 mx-1">
                <v-col class="px-1 py-1 text">
                    Vid eventuella frågor ring {{ perfectaPhone }}
                </v-col>
            </v-row>
        </v-container>
        <v-snackbar
                app
                v-model="snackbar"
                multi-line
                :color="this.errorMessage ? 'red accent-4' : 'green'"
                :top=true
                timeout="3000"
            >
                {{ successMessage ? successMessage : errorMessage }}
        </v-snackbar>
        <v-snackbar
			app
			v-model="showUpdateSnackbar"
			multi-line
			color="primary"
			top
			:right="!$vuetify.breakpoint.mobile"
			timeout="-1"
		>
			Ny version tillgänglig
			<template v-slot:action="{ attrs }">
				<v-btn
					color="blue"
					text
					v-bind="attrs"
					@click="refresh"
				>
					Hämta ny version
				</v-btn>
			</template>
		</v-snackbar>
        <div class="footer" style="margin-top:25px">
            <span class="version">v. {{ version }}</span>
            <span class="powered-by">
                <span class="bollar-container">
                    <a href="https://www.coredination.se/"><img class="bollar" src="img/bollar.png"/></a>
                </span>
                <span>
                    <a href="https://www.coredination.se/">Powered by Coredination</a>
                </span>
            </span>
        </div>
    </div>
    <div v-else-if="this.loading && this.authenticated && !this.isClosed">
        <v-progress-linear
            indeterminate
            color="primary"
            height="2">
        </v-progress-linear>
    </div>
    <div v-else-if="this.isClosed">
        <v-container class="px-1">
            <v-row class="px-1 mx-1">
                <v-col class="px-1 py-1 text" v-html="closedJobHtml">
                </v-col>
            </v-row>
        </v-container>
    </div>
    <div v-else></div>

</template>

<script>
const moment = require('moment');
import Note from './Note.vue';
import Vue from 'vue';
export default {
    name: 'Job',
    mounted() {
        if (this.$jobId) {
            this.fetchJob();
        } else {
            this.authenticated = false;
            this.loading = false;
        }
        this.$root.$on('asset-created', (asset) => {
            this.addAsset(asset);
        });
        this.$root.$on('asset-updated', (asset) => {
            this.updateAssets(asset);
        })
    },
    created() {
        document.addEventListener('swUpdated', this.showAvailableUpdateSnack, { once: true })
        navigator.serviceWorker.addEventListener('controllerchange', () => {
            console.log('controllerchange');
            if (this.refreshing) return;
            console.log('refreshing');
            this.refreshing = true;
            window.location.reload();
        });
    },
    data: () => ({
        loading: false,
        job: null,
        objectImageUrl: '',
        address: '',
        addressHref: '',
        contactName: '',
        contactPhone: '',
        contactEmailAddress: '',
        description: '',
        accepted: false,
        declined: false,
        finished: false,
        name: '',
        errorMessage: null,
        successMessage: null,
        snackbar: false,
        acceptedBy: '',
        comment: '',
        infoText: 'Tack för ditt svar. Perfecta är nu informerade om att uppdraget är ',
        finishedDate: '',
        finishedTime: '',
        perfectaPhone: '08-508 655 55',
        perfectaEmail: 'support@perfectastorkok.se',
        asset: null,
        authenticated: false,
        showDocuments: true,
        latestFinished: '',
        notes: [],
        file: null,
        projectNo: '',
        customerProjectAssets: [],
        customerProject: null,
        showUpdateSnackbar: false,
        inventoryJob: false,
        yearlyInspection: false
    }),
    methods: {
        showAvailableUpdateSnack(event) {
			this.registration = event.detail;
			this.showUpdateSnackbar = true;
		},
		refresh() {
			this.showUpdateSnackbar = false;
			if (!this.registration) {
				console.error("Can't refresh - No registration");
				return;
			}
			if (!this.registration.waiting) {
				console.error("Can't refresh - Registration is not waiting");
				return;
			}
			console.log("Skip waiting");
			this.registration.waiting.postMessage("skipWaiting");
		},
        fetchJob() {
            this.loading = true;
            this.$api.get('get_job/' + this.$jobId + '?access_token=' + this.$accessToken)
                .then(response => {
                    this.authenticated = true;
                    this.job = response.data;
                    Vue.prototype.$job = response.data;
                    this.setup();
                    this.setupImageUrl();
                    this.setupNotes();
                }, this)
                .catch(error => {
                    this.authenticated = false;
                    this.job = null;
                    console.error('could not fetch job: ' + error);
                    this.snack('could not fetch job: ' + error);
                }, this)
                .finally(() => {
                    this.loading = false;
                }, this);
        },
        async fetchCustomerProjectAssets(customerProjectId) {
            let response = await this.$api.get('get_assets/' + customerProjectId + '/' + this.$jobId + '?access_token=' + this.$accessToken)
                .catch(error => {
                    console.error('could not fetch assets: ' + error);
                    this.snack('could not fetch assets: ' + error);
                }, this)
            if (response && response.status == 200) {
                let assets = response.data.filter(asset => asset.state != 'DISCARDED');
                this.customerProjectAssets = assets;
                Vue.prototype.$customerProjectAssets = assets;
            }
        },
        fetchCustomerProject(customerProjectId) {
            this.$api.get('get_customer_project/' + customerProjectId + '/' + this.$jobId + '?access_token=' + this.$accessToken)
                .then(response => {
                    this.customerProject = response.data;
                    Vue.prototype.$customerProject = response.data;
                }, this)
                .catch(error => {
                    console.error('could not fetch customer project: ' + error);
                    this.snack('could not fetch customer project: ' + error);
                }, this)
        },
        setup() {
            if (this.job) {
                let address = this.job && this.job.destinations 
                                && this.job.destinations.length > 0
                                && this.job.destinations[0]
                                && this.job.destinations[0].location
                                && this.job.destinations[0].location.placeName;
                this.address = address || '';
                this.addresHref = 'https://maps.google.com/?q=' + address;
                this.contactName = this.job && this.job.contacts && this.job.contacts[0] && this.job.contacts[0].name;
                this.contactPhone = this.job && this.job.contacts && this.job.contacts[0] && this.job.contacts[0].phoneNo;
                this.contactEmailAddress = this.job && this.job.contacts && this.job.contacts[0] && this.job.contacts[0].emailAddress;
                this.description = this.job && this.job.description;
                this.accepted = ['ACCEPTED', 'STARTED'].includes(this.getResourceState()) || false;
                this.declined = this.getResourceState() == 'DECLINED' || false;
                this.finished = this.getResourceState() == 'FINISHED' || false;
                this.projectNo = this.job.customerProjectNo || this.job.customerProjectNoText;
                this.inventoryJob = this.job.activityName == 'Inventering';
                this.yearlyInspection = this.job.activityName == 'Årlig besiktning' || this.job.activityName == 'Årlig service' || this.job.activityId == 950090053;
                if (this.finished) {
                    this.setupFinished();
                }
                if (this.accepted) {
                    this.setupAcceptedBy();
                    this.setupLatestFinishedDate();
                }
                if (this.inventoryOrInspectionJob) {
                    if (this.job.customerProjectId) {
                        this.fetchCustomerProjectAssets(this.job.customerProjectId);
                        this.fetchCustomerProject(this.job.customerProjectId);
                    } else {
                        Vue.prototype.$customerProjectAssets = [];
                        Vue.prototype.$customerProject = null;
                    }
                }
            }
            this.loading = false;
        },
        async accept() {
            if (this.validate()) {
                let response = await this.addNote('Accepterad av: ' + this.name);
                if (response && response.status == 200) {
                    let resourceId = this.getAssignedResourceId();
                    if (resourceId) {
                        this.$api.put('set_state/' + this.$jobId + '/' + resourceId + '/STARTED' + '?access_token=' + this.$accessToken)
                        .then((response) => {
                            this.job = response.data;
                            this.accepted = true;
                            this.setupAcceptedBy();
                            this.setupLatestFinishedDate();
                        }, this)
                        .catch(error => {
                            console.error('could not accept job: ' + error);
                            this.snack('could not accept job: ' + error);
                        }, this)
                        .finally(() => {
                        }
                    )
                    } else {
                        console.error('could not accept job: missing resource id');
                        this.snack('could not accept job: missing resource id');
                    }
                }
            }
        },
        async decline() {
            if (this.validate()) {
                let response = await this.addNote('Avböjd av: ' + this.name);
                let resourceId = this.getAssignedResourceId();
                if (response && response.status == 200) {
                    if (resourceId) {
                        this.$api.put('set_state/' + this.$jobId + '/' + resourceId + '/DECLINED' + '?access_token=' + this.$accessToken)
                        .then((response) => {
                            this.job = response.data;
                            this.declined = true;
                        }, this)
                        .catch(error => {
                            console.error('could not decline job: ' + error);
                            this.snack('could not decline job: ' + error);
                        }, this)
                    } else {
                        console.error('could not decline job: missing resource id');
                        this.snack('could not decline job: missing resource id');
                    }
                }
            }
        },
        async finishJob() {
            if (this.validate()) {
                if (this.comment) {
                    await this.addNote(this.name + ': ' + this.comment);
                }
                let response = await this.addNote('Färdigställt av: ' + this.name);
                if (response && response.status == 200) {
                    let resourceId = this.getAssignedResourceId();
                    if (resourceId) {
                        this.$api.put('set_state/' + this.$jobId + '/' + resourceId + '/FINISHED' + '?access_token=' + this.$accessToken)
                        .then((response) => {
                            this.job = response.data;
                            this.finished = true;
                            this.setupFinished();
                        }, this)
                        .catch(error => {
                            console.error('could not finish job: ' + error);
                            this.snack('could not finish job: ' + error);
                        }, this)
                    } else {
                        console.error('could not finish job: missing resource id');
                        this.snack('could not finish job: missing resource id');
                    }
                }
            }
        },
        validate() {
            let valid = false;
            let issues = []
            if (this.name == '' || !this.name) {
                issues.push('Namn');
            }
            if (!valid && issues.length > 0) {
                let errorMessage = 'Ange: ' + issues.join(', ');
                this.snack(errorMessage);
            } else {
               valid = true;
            }
            return valid;
        },
        clickAddNote() {
            if (this.validate() && this.comment) {
                let comment = this.name + ': ' + this.comment;
                this.addNote(comment);
                this.name = '';
                this.comment = '';
            }
        },
        async addNote(comment) {
            let note = this.createNote(comment);
            let jsonNote = JSON.stringify(note)
            if (note) {
                let response = await this.$api.post('add_note/' + this.$jobId + '?access_token=' + this.$accessToken, jsonNote)
                    .catch(error => {
                        console.error('could not post note: ' + error);
                        this.snack('could not post note: ' + error)
                    }, this)
                if (response && response.status == 200) {
                    if (response.data) this.notes.push(response.data);
                }
                return response;
            }
        },
        createNote(comment) {
            let note = {
                'type': 'NOTE',
                'comment': comment,
                'discrepancy': false,
                'internal': false
            }
            return note;
        },
        getAssignedResourceId() {
            if (!this.job || !this.job.resources || this.job.resources.length == 0) {
                return null
            }
            let resources = this.job && this.job.resources;
            if (resources) {
                if (resources.length == 1) {
                    return resources[0].id;
                } else {
                    // I don't know..return ID from first resource with state assigned?
                    let resource = resources.find(resource => resource.state == 'ASSIGNED');
                    return resource.id;
                }
            }
        },
        getResourceState() {
            if (!this.job || !this.job.resources || this.job.resources.length == 0) {
                return null
            }
            let resources = this.job && this.job.resources;
            if (resources) {
                if (resources.length == 1) {
                    return resources[0].state;
                } else {
                    let resource = resources.find(resource => (resource.state == 'ACCEPTED' || resource.state == 'STARTED' || resource.state == 'DECLINED'));
                    return resource && resource.state;
                }
            }
            return null;
        },
        setupAcceptedBy() {
            if (!this.job) return;
            let acceptedEvent = this.job.events && this.job.events.find(event => event && event.comment && event.comment.includes('Accepterad av:'));
            if (acceptedEvent) {
                let acceptedBy = acceptedEvent.comment;
                acceptedBy += ' ';
                acceptedBy += moment(acceptedEvent.eventTimeStamp).format('YYYY-MM-DD HH:mm');
                this.acceptedBy = acceptedBy;
            }
        },
        setupFinished() {
            let finishedTimestamp = this.job && this.job.endedTimeStamp && moment(this.job.endedTimeStamp).format('YY-MM-DD HH:mm');
            if (finishedTimestamp) {
                this.finishedDate = finishedTimestamp.split(' ')[0];
                this.finishedTime = finishedTimestamp.split(' ')[1];
            }
        },
        setupLatestFinishedDate() {
            let creationTimeStamp = this.job && this.job.creationTimeStamp;
            let latestFinishedTimestamp = this.generateLatestFinishedDate(creationTimeStamp);
            let latestFinishedDate = moment(latestFinishedTimestamp).format('YYYY-MM-DD HH:mm');
            this.latestFinished = 'Påbörja innan ' + latestFinishedDate;
        },
        generateLatestFinishedDate(timestamp) {
            let acceptedDate = new Date(timestamp);
            let dayOfWeek = acceptedDate.getDay() // sunday = 0 -> saturday 6
            if (dayOfWeek >= 0 && dayOfWeek <= 3) { // job accepted sunday to wedensday (both included) => add two days
                return acceptedDate.setDate(acceptedDate.getDate() + 2);
            } else if (dayOfWeek == 4 || dayOfWeek == 5) { // job accepted thursday or friday => next monday/tuesday = add 4
                return acceptedDate.setDate(acceptedDate.getDate() + 4);
            } else if (dayOfWeek == 6) { // job accepted saturday => tuesday = add 4
                return acceptedDate.setDate(acceptedDate.getDate() + 3);
            } else return timestamp;
        },
        setupImageUrl() {
            if (!this.job || !this.job.documents || this.job.documents.length == 0) this.objectImageUrl = '../assets/images/perfecta_full_logo.png';
            let documents = this.job.documents;
            if (documents && documents.length == 1) {
                let document = documents[0].internal ? null : documents[0]
                if (document && document.mimeType && document.mimeType.includes('image') && document.uuid) {
                    this.objectImageUrl = this.$cdnConfig.baseUrl + document.thumbUrl + '?access_token=' + this.$accessToken
                } else {
                    this.objectImageUrl = '../assets/images/perfecta_full_logo.png';
                }
            } else if (documents && documents.length > 1) {
                let firstImageDocument = documents.find(doc => doc && doc.mimeType && doc.mimeType.includes('image') && !doc.internal);
                if (firstImageDocument && firstImageDocument.uuid) {
                    this.objectImageUrl = this.$cdnConfig.baseUrl + firstImageDocument.thumbUrl + '?access_token=' + this.$accessToken
                } else {
                    this.objectImageUrl = '../assets/images/perfecta_full_logo.png';
                } 
            } else {
                this.objectImageUrl = '../assets/images/perfecta_full_logo.png';
            }
        },
        setupNotes() {
            if (!this.job) return;
            let notes = this.job && this.job.events && this.job.events.filter(event => event.comment && event.type == 'NOTE' && !event.internal);
            this.notes = notes;
        },
        snack(msg, success) {
            if (success) {
                this.errorMessage = null;
                this.successMessage = msg;
            } else {
                this.successMessage = null;
                this.errorMessage = msg;
            }
            this.snackbar = true
            setTimeout(() => {
                this.successMessage = null
                this.errorMessage = null
                this.snackbar = false
            }, 3000)
        },
        clickUploadDocument() {
            if (!this.file) return;
            console.log(this.file);
            if (this.file.size && this.file.size > 10000000) {
                this.snack('File is too large. Current maximum size is 10 MB');
                this.file = null;
                return;
            }
            let formData = new FormData();
            formData.append('file', this.file);
            let headers = { 'Content-Type': 'multipart/form-data' }
            this.$api.postDocument('upload_document/' + this.$jobId + '?access_token=' + this.$accessToken, formData, headers)
            .then( response => {
                let documentId = response.data.document.id;
                this.attachDocument(documentId);
            })
            .catch( error => {
                let errorJson = error.toJSON();
                this.snack('could not upload document: ' + error.message);
                console.error('Error',errorJson);
            })
            .finally( () => {
            })
        },
        attachDocument(documentId) {
            if (!documentId) return;
            this.$api.put('attach_document/' + this.$jobId + '/' + documentId + '?access_token=' + this.$accessToken)
            .then( response => {
                this.snack('Dokument laddad upp!', true)
                this.file = null;
                this.fetchJob();
                console.log(response);
            })
            .catch( error => {
                let errorJson = error.toJSON();
                this.snack('could not attach document: ' + error.message);
                console.error('Error', errorJson);
            })
            .finally( () => {
            })
        },
        fileSelected(file) {
            if (file && file.size > 10000000) {
                this.snack('File is too large. Current maximum size is 10 MB');
                this.file = null;
            }
        },
        addAsset(asset) {
            if (asset && asset.id) {
                this.customerProjectAssets.push(asset);
            }
        },
        updateAssets(asset) {
            if (asset && asset.id) {
                this.customerProjectAssets = this.customerProjectAssets.filter( a => a.id == asset.id);
                this.customerProjectAssets.push(asset);
            }
        },
        inspected(asset) {
            if (!asset) return false;
            let customFields = asset.customFields;
            if (!customFields) return false;
            let inspectionDateField = customFields.find( field => field.name == 'senastebesiktad' );
            if (inspectionDateField && inspectionDateField.value) {
                const sixtyDaysInMilliseconds = 5184000000;
                let today = new Date();
                let lastInspectionDate = new Date(inspectionDateField.value);
                return (today - lastInspectionDate) < sixtyDaysInMilliseconds;
            } else return false;
        },
        clickAsset(asset) {
            this.$router.push({ name: 'Asset', params:{ id: asset.id, type: asset.assetTypeName , from: 'job', yearlyInspection: this.yearlyInspection, resourceName: this.resourceName }});
        }
    },
    computed: {
        extendedTime() {
            let extendedCustomField = this.job && this.job.customFields && this.job.customFields.find(field => field.name == 'frlngningpbrjatarbete');
            return extendedCustomField && extendedCustomField.value ? 'OBS! Förlängt påbörjat arbete: ' + moment(parseInt(extendedCustomField.value)).format('YYYY-MM-DD HH:mm') : false;
        },
        version() {
            return this.$version
        },
        isBasicFormComplete() {
            if (this.yearlyInspection) return true;
            let forms = this.job && this.job.forms;
            if (forms) {
                let basicForm = forms.find(form => form.title && form.title.toLowerCase() && form.title.toLowerCase().indexOf('shopinformation') == 0);
                if (basicForm && basicForm.formState == 'COMPLETE') {
                    return true;
                } else return false;
            } else return false;
        },
        addObjectText() {
            return 'Lägg till Anläggningstillgång/\nMaskinpark';
        },
        isClosed() {
            return this.job && this.job.state && this.job.state == 'CLOSED';
        },
        closedJobHtml() {
            return 'Uppdraget är stängd. <br><br> För frågor, ring <a href="tel:' + this.perfectaPhone + '">' + this.perfectaPhone + '</a> eller maila <a href="mailto:' + this.perfectaEmail + '">' + this.perfectaEmail + '</a> och uppge updragsnummer ' + this.job.jobNo + '.';
        },
        inventoryOrInspectionJob() {
            return this.inventoryJob || this.yearlyInspection;
        },
        resourceName() {
            return this.job && this.job.resources && this.job.resources[0] && (this.job.resources[0].fullName ||  this.job.resources[0].userName);
        }
    },
    components: {
		Note
	}
}
</script>

<style lang="scss" scoped>
.text {
    font-size: 14px;
}
.details {
    float: left;
    width: 70%;
    
}
.missing {
    border-style: solid;
    border-width: 2px;
    border-color: red;
}
.accepted-by {
    border-style: solid;
    border-width: 2px;
    border-color: green; 
}
.latest-date {
    border-style: solid;
    border-width: 2px;
    border-color: orangered;
}
.disabled {
    opacity: 0.5;
    pointer-events: none;
}
.not-inspected {
    background-color: #ffd580;
}
.inspected {
    background-color: lightgreen;
}
.inspection-needed {
    color: red;
    font-size: 12px;
    font-weight: bold;
    padding: auto;
}
.job-asset {
    padding-left: 8px;
}
</style>